import type { Benefit } from '../types/offer';
export const benefits: Benefit[] = [{
  icon: 'target',
  title: 'সবচেয়ে সস্তা অপশন হওয়া বন্ধ করুন',
  description: 'যেকোনো মার্কেটে নিজেকে প্রিমিয়াম চয়েস হিসেবে পজিশন করতে শিখুন। ৯০ দিনের মধ্যে আপনার আয়ের সম্ভাবনা দ্বিগুণ (বা তিন গুণ) করুন।'
}, {
  icon: 'muscle',
  title: 'অটুট আত্মবিশ্বাস গড়ে তুলুন',
  description: 'যে মনস্তত্ত্ব আত্মসংশয়কে অবিচল বিশ্বাসে বদলে দেয়, তাতে দক্ষ হয়ে উঠুন। পরিস্থিতি যা-ই হোক, আর কখনো নিজেকে ছোট বা অযোগ্য মনে হবে না।'
}, {
  icon: 'pressure',
  title: 'চাপের মুহূর্তে জিতুন',
  description: 'চরম চাপে চ্যাম্পিয়নরা যে মাইন্ডসেট ব্যবহার করে, ঠিক সেটিই তৈরি করুন। চাকরির ইন্টারভিউ, ক্লায়েন্ট প্রেজেন্টেশন ও জীবনের বড় সিদ্ধান্তে জিতে যান।'
}, {
  icon: 'wealth',
  title: 'টেকসই সম্পদ তৈরি করুন',
  description: 'সময়ের বিনিময়ে টাকা নেওয়া বন্ধ করুন। এমন সিস্টেম গড়ুন যা স্বয়ংক্রিয়ভাবে আয় করে। প্রমাণিত আর্জেন্টাইন বিজনেস সাইকোলজি দিয়ে আর্থিক স্বাধীনতা অর্জন করুন।'
}, {
  icon: 'brain',
  title: 'নিজের বিশ্বাসগুলো রিপ্রোগ্রাম করুন',
  description: 'যে সীমাবদ্ধ বিশ্বাসগুলো আপনাকে গরিব ও আটকে রাখে, সেগুলো মুছে ফেলুন। বিশ্বের সবচেয়ে সফল মানুষদের চিন্তার ধরন গ্রহণ করুন।'
}, {
  icon: 'community',
  title: 'একটি এলিট কমিউনিটিতে যোগ দিন',
  description: 'একই স্বপ্ন নিয়ে এগোনো ২,৮৪৭+ উচ্চাকাঙ্ক্ষী বাংলাদেশি তরুণের সাথে সংযোগ। নেটওয়ার্ক করুন, একসাথে কাজ করুন, একসাথে বড় হন।'
}];
